module.exports = __webpack_public_path__ + "static/icon-dots-b92b54c177c858605c1fd918b8caefd2.svg";